import React, { useEffect, useRef, useState } from 'react'
import { withStyles } from '@mui/styles'
import { FlickerCode } from './flicker-code'
import { FlickerRenderer } from './flicker-renderer'
import { SquareIconButton } from 'base/components/buttons'
import SlowerSvg from 'assets/images/icons/slower.svg'
import FasterSvg from 'assets/images/icons/faster.svg'
import ReloadSvg from 'assets/images/icons/reload.svg'
import ZoomMinusSvg from 'assets/images/icons/zoom_minus.svg'
import ZoomPlusSvg from 'assets/images/icons/zoom_plus.svg'

const TICK_MIN = 0
const TICK_MAX = 1000
const DECREASE_TICK_DELTA = 5
const INCREASE_TICK_DELTA = 5
const ZOOM_DECREASE_MULTIPLIER = 0.95
const ZOOM_INCREASE_MULTIPLIER = 1.05

const FLICKERCODE_HEIGHT = 120
const FLICKERCODE_WIDTH = 200
const defaultSize = { height: FLICKERCODE_HEIGHT, width: FLICKERCODE_WIDTH }
const defaultTickTimeout = 100

const testProtocolData = '1F85012392301285564445303534373236303132313832303135303936303244'
const testDataEl1 = 'DE05472601218201509602'
const testStartCode = '2392301285'

const ChipTan = props => {
  const { classes, data } = props
  const canvasEl = useRef()
  const flickerRenderer = useRef()
  const timeoutRef = useRef()

  const [size, setSize] = useState(defaultSize)
  const [tickTimeout, setTickTimeout] = useState(defaultTickTimeout)

  const start = () => {
    if (timeoutRef.current) return

    if (!window) return null
    timeoutRef.current = window.setTimeout(() => {
      flickerRenderer.current.step()

      timeoutRef.current = null
      start()
    }, tickTimeout)
  }

  const stop = () => {
    if (!timeoutRef.current) return

    window.clearTimeout(timeoutRef.current)
    timeoutRef.current = null
  }

  useEffect(() => {
    flickerRenderer.current = new FlickerRenderer(canvasEl.current)
    if (data) {
      flickerRenderer.current.setCode(new FlickerCode(data))
      start()
    }

    return function cleanup() {
      stop()
    }
  })

  const decreaseTickrate = () => {
    setTickTimeout(Math.min(TICK_MAX, tickTimeout + DECREASE_TICK_DELTA))
  }
  const increaseTickrate = () => {
    setTickTimeout(Math.max(TICK_MIN, tickTimeout - INCREASE_TICK_DELTA))
  }
  const reset = () => {
    setSize(defaultSize)
    setTickTimeout(defaultTickTimeout)
  }
  const zoomIn = () => {
    setSize({
      ...size,
      width: Math.abs(size.width * ZOOM_INCREASE_MULTIPLIER),
    })
  }
  const zoomOut = () => {
    setSize({
      ...size,
      width: Math.abs(size.width * ZOOM_DECREASE_MULTIPLIER),
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.buttons}>
        <SquareIconButton icon={ZoomPlusSvg} size="medium" onClick={zoomIn} />
        <SquareIconButton icon={ZoomMinusSvg} size="medium" onClick={zoomOut} />
        <SquareIconButton icon={FasterSvg} size="medium" onClick={increaseTickrate} />
        <SquareIconButton icon={SlowerSvg} size="medium" onClick={decreaseTickrate} />
        <SquareIconButton icon={ReloadSvg} size="medium" onClick={reset} />
      </div>
      <canvas ref={canvasEl} className={classes.canvas} width={size.width} height={size.height} />
    </div>
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    width: FLICKERCODE_WIDTH,
  },
  canvas: {
    marginTop: 16,
    borderRadius: 8,
    padding: '0 10px 10px',
    background: 'black',
    maxWidth: '100%',
    height: FLICKERCODE_HEIGHT,
  },
})

export default withStyles(styles)(ChipTan)
